import angular from 'angular';

declare var LtFramework: lt.Static;

let basePath: string;
let baseKey: string;
if (typeof(LtFramework.global.lt) !== 'undefined'
	&& typeof(LtFramework.global.lt.api) !== 'undefined'
	&& LtFramework.global.lt.api != null
	&& LtFramework.global.lt.api.commprefs != null) {

	basePath = LtFramework.global.lt.api.commprefs;
	baseKey = LtFramework.global.lt.api.commprefsKey;
} else {
	basePath = 'https://api.lifetimefitness.com/qa/commprefs';
	baseKey = '2e77f50f231e4647b3339a5494470361';
}

// SSO ID needs to be in the header of every request to CommPrefs
const globalHeaders = {
	'X-LTF-SSOID': (): string => {
		const store = LtFramework.getStore('ProfileStore') as lt.IProfileStore;
		return store.getInitialData().sso;
	},
	'ocp-apim-subscription-key' : baseKey
};

angular.module('ltt.commprefs.api', ['ngResource'])

	.factory('CommunicationChannelFactory', ['$resource', ($resource: ng.resource.IResourceService): CommPrefsApi.ICommunicationChannelFactory => {
		return $resource<CommPrefsApi.ICommunicationChannelResource>(`${basePath}/communication-channels`, {}, {
			query: { headers: globalHeaders, isArray: true, method: 'GET' }
		});
	}])

	.factory('CommunicationPreferenceFactory', ['$resource', ($resource: ng.resource.IResourceService): CommPrefsApi.ICommunicationPreferenceFactory => {
		return $resource<CommPrefsApi.ICommunicationPreferenceResource>(`${basePath}/communication-preferences/:Id`, {
			Id: '@Id'
		}, {
			create: { headers: globalHeaders, method: 'POST' },
			get: { headers: globalHeaders, method: 'GET' },
			update: { headers: globalHeaders, method: 'PUT' }
		}) as CommPrefsApi.ICommunicationPreferenceFactory;
	}])

	.factory('CommunicationSummaryFactory', ['$resource', ($resource: ng.resource.IResourceService): CommPrefsApi.ICommunicationSummaryFactory => {
		return $resource<CommPrefsApi.ICommunicationSummaryResource>(`${basePath}/communication-summary`, {}, {
			get: { headers: globalHeaders, method: 'GET' }
		});
	}])

	.factory('CommunicationValueFactory', ['$resource', ($resource: ng.resource.IResourceService): CommPrefsApi.ICommunicationValueFactory => {
		return $resource<CommPrefsApi.ICommunicationValueResource>(`${basePath}/communication-values`, {}, {
			query: { headers: globalHeaders, isArray: true, method: 'GET' },
			save: { headers: globalHeaders, method: 'PUT' }
		});
	}])

	.factory('SendConfirmationCodeFactory', ['$resource', ($resource: ng.resource.IResourceService): CommPrefsApi.ISendConfirmationCodeFactory => {
		return $resource<ng.resource.IResource<void>>(`${basePath}/services/sendConfirmationCode`, {}, {
			save: {
				headers: globalHeaders,
				method: 'POST'
			}
		});
	}]);
